const INVALID_DATE = 'Invalid Date';
const format_map = {
  dd: day => day?.toString()?.padStart(2, '0'),
  Do: {
    1: '1st',
    2: '2nd',
    3: '3rd',
    4: '4th',
    5: '5th',
    6: '6th',
    7: '7th',
    8: '8th',
    9: '9th',
    10: '10th',
    11: '11th',
    12: '12th',
    13: '13th',
    14: '14th',
    15: '15th',
    16: '16th',
    17: '17th',
    18: '18th',
    19: '19th',
    20: '20th',
    21: '21st',
    22: '22nd',
    23: '23rd',
    24: '24th',
    25: '25th',
    26: '26th',
    27: '27th',
    28: '28th',
    29: '29th',
    30: '30th',
    31: '31st'
  },
  MMM: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
  },
  Mm: month => (month + 1)?.toString()?.padStart(2, '0'),
  hh: hours =>
    hours <= 12
      ? String(hours).padStart(2, '0')
      : String(hours - 12).padStart(2, '0'), // only do this when hours > 12
  mm: minutes => String(minutes).padStart(2, '0'),
  a: hours => {
    if (hours - 12 >= 0) return 'pm';
    return 'am';
  },
  yy: year => year.toString().substr(-2),
  yyyy: year => year.toString()
};

export const format_date = (date, format) => {
  try {
    const formatted_date = format.split('$').map(identifier => {
      if (identifier && Object.keys(format_map).includes(identifier)) {
        switch (identifier) {
          case 'dd':
            return format_map.dd(date.getDate());
          case 'Do':
            return format_map.Do[date.getDate()];
          case 'MMM':
            return format_map.MMM[date.getMonth() + 1]; // getMonth is zero based
          case 'Mm':
            return format_map.Mm(date.getMonth());
          case 'hh':
            return format_map.hh(date.getHours());
          case 'mm':
            return format_map.mm(date.getMinutes());
          case 'a':
            return format_map.a(date.getHours());
          case 'yy':
            return format_map.yy(date.getFullYear());
          case 'yyyy':
            return format_map.yyyy(date.getFullYear());
          default:
            return identifier;
        }
      }
      return identifier;
    });
    return formatted_date.join('');
  } catch (e) {
    return INVALID_DATE;
  }
};

export const toFromNow = date => {
  const current_date = new Date();
  const difference = Math.abs(current_date - date);
  const hours = Math.floor(difference / (60 * 60 * 1000));
  const minutes = Math.floor(difference / (60 * 1000));
  const days = Math.floor(difference / (24 * 60 * 60 * 1000));
  const months = Math.floor(difference / (30 * 24 * 60 * 60 * 1000));
  const years = Math.floor(difference / (12 * 30 * 24 * 60 * 60 * 1000));
  if (date < current_date) {
    if (years > 0)
      if (years === 1) return 'a year ago';
      else return `${years} years ago`;
    if (months > 0)
      if (months === 1) return 'a month ago';
      else return `${months} months ago`;
    if (days > 0)
      if (days === 1) return 'a day ago';
      else return `${days} days ago`;
    if (hours > 0)
      if (hours === 1) return 'an hour ago';
      else return `${hours} hours ago`;
    if (minutes > 0)
      if (minutes === 1) return 'a minute ago';
      else return `${minutes} minutes ago`;
    return 'a few seconds ago';
  }
  if (date > current_date) {
    if (hours > 0)
      if (hours === 1) return 'in an hour';
      else return `in ${hours} hours`;
    if (minutes > 0)
      if (minutes === 1) return 'in a minute';
      else return `in ${minutes} minutes`;
    return 'in a few seconds';
  }
  return 'just now';
};

export const isLeapYear = year => {
  if (year % 400 === 0) return true;
  if (year % 100 === 0) return false;
  if (year % 4 === 0) return true;
  return false;
};

const monthWith31Days = [1, 3, 5, 7, 8, 10, 12];

const monthWith30Days = [4, 6, 9, 11];

export const getLastDayOfTheMonth = (month, year) => {
  if (!month || !year) return null;
  if (month === 2) {
    if (isLeapYear(year)) return 29;
    return 28;
  }
  if (monthWith31Days.indexOf(month) > -1) return 31;
  if (monthWith30Days.indexOf(month) > -1) return 30;
};
